import { useEffect, useState } from "react";
import { TrashIcon } from '@heroicons/react/24/outline';
import axios from 'axios';
const CustomerProfileForm = ({ customerprofileOpen, itemId, setCustomerprofileOpen }) => {
    const [formData, setFormData] = useState({
        category: "",
        businessNature: "",
        property: "",
        leadSource: "",
        installationType: "",
        replacementDetails: [],
        electricityImage: null,
        electricityNumber: '',
        sitePhotos: [],
        customerType: 'New'
    });
    useEffect(() => {
        if (formData.category === "B2b") {
            setFormData((prev) => ({
                ...prev,
                businessNature: "Residential"
            }));
        }
    }, [formData.category]);
    // Handles changes in text/select inputs
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // If installationType is "Replacement" or "Partial Replacement", add at least one AC detail
        if (name === "installationType" && (value === "Replacement" || value === "Partial Replacement")) {
            setFormData((prev) => ({
                ...prev,
                replacementDetails: prev.replacementDetails.length === 0 ? [{ totalOldACs: "", oldACBrand: "", tonnage: "", iseer: "", beeImage: null }] : prev.replacementDetails,
            }));
        } else if (name === "installationType") {
            setFormData((prev) => ({ ...prev, replacementDetails: [] })); // Reset if it's not replacement
        }
    };

    // Handles changes in replacement details
    const handleReplacementDetailChange = (index, e) => {
        const { name, value } = e.target;
        const updatedDetails = [...formData.replacementDetails];
        updatedDetails[index][name] = value;
        setFormData({ ...formData, replacementDetails: updatedDetails });
    };

    // Handles image uploads
    const handleImageChange = (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const updatedDetails = [...formData.replacementDetails];
        updatedDetails[index]["beeImage"] = file;
        setFormData({ ...formData, replacementDetails: updatedDetails });
    };

    // Adds a new AC detail
    const addReplacementDetail = () => {
        setFormData({
            ...formData,
            replacementDetails: [...formData.replacementDetails, { totalOldACs: "", oldACBrand: "", tonnage: "", iseer: "", beeImage: null }],
        });
    };

    // Handles form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate required fields
        if (!formData.category || !formData.businessNature ||
            !formData.property || !formData.leadSource ||
            !formData.installationType) {
            alert("All fields are required.");
            return;
        }

        try {
            const formDataToSend = new FormData();

            // Append form data as JSON string
            formDataToSend.append('formData', JSON.stringify({
                category: formData.category,
                businessNature: formData.businessNature,
                property: formData.property,
                leadSource: formData.leadSource,
                installationType: formData.installationType,
                replacementDetails: formData.replacementDetails || [],
                // electricityDetails: formData.electricityDetails || {},
                // electricityNumber: formData.electricityNumber
            }));

            if (Array.isArray(formData.replacementDetails)) {
                formData.replacementDetails.forEach((detail, index) => {
                    if (detail.beeImage instanceof File) {
                        formDataToSend.append(`beeImages`, detail.beeImage);
                    }
                });
            }

            const response = await axios.post(`${process.env.REACT_APP_MYBACKEND_PI}/api/customerprofile/customers/${itemId}`, formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });

            if (response.data.success) {
                alert('Customer profile created successfully!');
                setCustomerprofileOpen(false);
            } else {
                throw new Error(response.data.message);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Error creating customer profile. Please try again.');
        }
    };



    const handleElectricityImageChange = (e) => {
        const file = e.target.files[0]; // Get the selected file
        if (file) {
            setFormData((prevData) => ({
                ...prevData,
                electricityImage: file, // Store the file in state
            }));
        }
    };

    // Handle multiple site photos upload
    const handleSitePhotosChange = (e) => {
        const files = Array.from(e.target.files); // Convert FileList to array
        setFormData((prevData) => ({
            ...prevData,
            sitePhotos: [...prevData.sitePhotos, ...files], // Append new images
        }));
    };
    const removeReplacementDetail = (index) => {
        setFormData((prevState) => ({
            ...prevState,
            replacementDetails: prevState.replacementDetails.filter((_, i) => i !== index),
        }));
    };

    const businessTypes = [
        "Cafe/Resto Bar",
        "PG/Co-living/Hostel",
        "Hotel",
        "Gym",
        "Office Space",
        "Independent Shop",
        "Residential",
        "Spa",
        "Salon",
        "Pharmacies",
        "Factory",
        "Clinic",
        "Retail Supermarket",
        "Laundry",
        "Coaching Centre",
        "Banquet",
        "School",
        "College",
        "Hospital"
    ].sort();



    const handleBussniessnatureChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleDeleteElectricityImage = () => {
        setFormData((prevData) => ({
            ...prevData,
            electricityImage: null, // Clear the electricity image
        }));
    };

    const handleDeleteSitePhoto = (index) => {
        setFormData((prevData) => {
            const updatedSitePhotos = [...prevData.sitePhotos];
            updatedSitePhotos.splice(index, 1); // Remove the selected photo
            return { ...prevData, sitePhotos: updatedSitePhotos };
        });
    };


    return (
        <>
            {customerprofileOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
                    onClick={() => setCustomerprofileOpen(false)} // Click outside to close
                >
                    <div
                        className="bg-white p-6 rounded-lg shadow-lg w-1/2 max-h-[90vh] overflow-y-auto"
                        onClick={(e) => e.stopPropagation()} // Prevent modal close when clicking inside
                    >

                        <h2 className="text-2xl font-semibold mb-6">Customer Profile Form</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="grid grid-cols-1 gap-4">
                                <div>
                                    <label htmlFor="category" className="block text-sm font-medium text-gray-700">
                                        Category
                                    </label>
                                    <select
                                        id="category"
                                        name="category"
                                        value={formData.category}
                                        onChange={handleInputChange}
                                        required
                                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                                    >
                                        <option value="" disabled>Select</option>
                                        <option value="B2B">B2B</option>
                                        <option value="B2C">B2C</option>
                                        <option value="B2b">B2 Small B</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>

                                <div>
                                    <label
                                        htmlFor="businessNature"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        Business Nature
                                    </label>
                                    <select
                                        id="businessNature"
                                        name="businessNature"
                                        value={formData.businessNature}
                                        onChange={handleBussniessnatureChange}
                                        disabled={formData.category === "B2b"}
                                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                                    >
                                        <option value="" disabled>Select Business Nature</option>
                                        {businessTypes.map((type) => (
                                            <option key={type} value={type}>
                                                {type}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="leadSource" className="block text-sm font-medium text-gray-700">Lead Source</label>
                                    <select
                                        id="leadSource"
                                        name="leadSource"
                                        value={formData.leadSource}
                                        onChange={handleInputChange}
                                        required
                                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                                    >
                                        <option value="">Select</option>
                                        <option value="Referral">Referral</option>
                                        <option value="Online Lead">Online Lead</option>
                                        <option value="Cold Visit">Cold Visit</option>
                                        <option value="Organic">Organic</option>
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="property" className="block text-sm font-medium text-gray-700">
                                        Property
                                    </label>
                                    <select
                                        id="property"
                                        name="property"
                                        value={formData.property}
                                        onChange={handleInputChange}
                                        required
                                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                                    >
                                        <option value="">Select</option>
                                        <option value="Rented">Rented</option>
                                        <option value="Owned">Owned</option>
                                    </select>
                                </div>
                                {/* <div>
                                    <label htmlFor="electricityNumber" className="block text-sm font-medium text-gray-700">
                                        Electricity Number
                                    </label>
                                    <input
                                        type="text"
                                        id="electricityNumber"
                                        name="electricityNumber"
                                        value={formData.electricityNumber}
                                        onChange={handleInputChange}

                                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                                    />
                                </div> */}

                                {/* <div>
                                    <label htmlFor="electricityImage" className="block text-sm font-medium text-gray-700">
                                        Electricity Bill Image
                                    </label>
                                    {formData.electricityImage ? (
                                        <div className="flex items-center justify-between">
                                            <span>{formData.electricityImage.name}</span>
                                            <button
                                                type="button"
                                                onClick={handleDeleteElectricityImage}
                                                className="text-red-500"
                                            >
                                                <TrashIcon className="w-4 h-4 text-red-500" />
                                            </button>
                                        </div>
                                    ) : (
                                        <input
                                            type="file"
                                            id="electricityImage"
                                            name="electricityImage"
                                            onChange={handleElectricityImageChange}
                                            className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                                        />
                                    )}
                                </div> */}

                                {/* <div>
                                    <label htmlFor="sitePhotos" className="block text-sm font-medium text-gray-700">
                                        Site Photos
                                    </label>
                                    {formData.sitePhotos.length > 0 ? (
                                        <div>
                                            {formData.sitePhotos.map((photo, index) => (
                                                <div key={index} className="flex items-center justify-between">
                                                    <span>{photo.name}</span>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleDeleteSitePhoto(index)}
                                                        className="text-red-500"
                                                    >
                                                        <TrashIcon className="w-4 h-4 text-red-500" />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <input
                                            type="file"
                                            id="sitePhotos"
                                            name="sitePhotos"
                                            multiple
                                            onChange={handleSitePhotosChange}

                                            className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                                        />
                                    )}
                                </div> */}


                                <div>
                                    <label htmlFor="installationType" className="block text-sm font-medium text-gray-700">
                                        Installation Type
                                    </label>
                                    <select
                                        id="installationType"
                                        name="installationType"
                                        value={formData.installationType}
                                        onChange={handleInputChange}
                                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                                    >
                                        <option value="">Select</option>
                                        <option value="New AC">New AC</option>
                                        <option value="Replacement">Replacement</option>
                                        <option value="Partial Replacement">Partial Replacement</option>
                                    </select>
                                </div>

                                {formData.replacementDetails.map((detail, index) => (
                                    <div key={index} className="border p-4 rounded-lg relative">
                                        <h3 className="text-lg font-medium text-gray-700">{formData.installationType} #{index + 1}</h3>
                                        <input
                                            type="number"
                                            name="totalOldACs"
                                            value={detail.totalOldACs}
                                            onChange={(e) => handleReplacementDetailChange(index, e)}
                                            placeholder="Total Old ACs"
                                            className="w-full p-2 border rounded-md mt-2"
                                        />
                                        <input
                                            type="text"
                                            name="oldACBrand"
                                            value={detail.oldACBrand}
                                            onChange={(e) => handleReplacementDetailChange(index, e)}
                                            placeholder="Old AC Brand"
                                            className="w-full p-2 border rounded-md mt-2"

                                        />
                                        <input
                                            type="number"
                                            name="tonnage"
                                            value={detail.tonnage}
                                            onChange={(e) => handleReplacementDetailChange(index, e)}
                                            placeholder="Tonnage"
                                            className="w-full p-2 border rounded-md mt-2"
                                        />
                                        <input
                                            type="number"
                                            name="iseer"
                                            value={detail.iseer}
                                            onChange={(e) => handleReplacementDetailChange(index, e)}
                                            placeholder="ISEER"
                                            className="w-full p-2 border rounded-md mt-2"
                                        />
                                        <input
                                            type="file"
                                            onChange={(e) => handleImageChange(index, e)}
                                            className="w-full p-2 border rounded-md mt-2"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => removeReplacementDetail(index)}
                                            className="absolute top-2 right-2 text-red-500"
                                        >
                                            <TrashIcon className="w-5 h-5 text-red-500" />
                                        </button>
                                    </div>
                                ))}

                                {(formData.installationType === "Replacement" || formData.installationType === "Partial Replacement") && (
                                    <button
                                        type="button"
                                        onClick={addReplacementDetail}
                                        className=" text-primary border-2 border-primary p-2 rounded-md w-1/4"
                                    >
                                        + Add More AC
                                    </button>
                                )}
                            </div>

                            <div className="flex justify-center items-center gap-4 mt-5 ">
                                <button type="submit" className="px-6 py-2 bg-primary text-white rounded-md">
                                    Submit
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            )}
        </>

    );
};

export default CustomerProfileForm;
